<script>
import PageLayout from '../Components/UI/PageLayout.vue'
import MainContainer from '../Components/UI/Content/MainContainer.vue'
import MainContent from '../Components/UI/Content/MainContent.vue'
import SimulationForm from '../Components/Simulation/SimulationForm.vue'
import mixinComponent from '../Mixins/mixinComponent'
import { globalVariablesMixin } from '../Mixins/global'
import SimulationView from '../Components/Simulation/SimulationView.vue'

export default {
  components: { SimulationView, SimulationForm, MainContent, MainContainer, PageLayout },
  mixins: [mixinComponent, globalVariablesMixin],

  data() {
    let urlParams = new URLSearchParams(window.location.search)
    return {
      index: urlParams.get('index'),
    }
  },

  methods: {
    changeIndex(index) {
      this.index = index
    },
  },

  mounted() {
    window.addEventListener('popstate', (event) => {
      let urlParams = new URLSearchParams(window.location.search)
      this.index = urlParams.get('index')
    })
  },
}
</script>
<template>
  <PageLayout menu="simulations-index">
    <MainContainer class="main-content">
      <MainContent>
        <SimulationForm v-if="index == 'creer'" @change-index="changeIndex" />
        <SimulationView v-if="index == 'simulation'" @change-index="changeIndex" />
      </MainContent>
    </MainContainer>
  </PageLayout>
</template>
